import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGiroCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGiroCard"><Path d="M6.5 8.5H8.5M2.5 4.5H21.5V19.5H2.5V4.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGiroCard;
